import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { ChevronLeft, ChevronRight } from '../../icons';
import { Button } from '../Button';
import { IconButton } from '../IconButton';
import { Typography } from '../Typography';
import styles from './PaginationControl.module.scss';
export function PaginationControl(props) {
    const { pageSize, pageNumber, total, compact, testId = 'pagination-controls', onPageNumberChange } = props;
    const start = (pageNumber - 1) * pageSize + 1;
    const end = Math.min(pageNumber * pageSize, total);
    const isPreviousDisabled = pageNumber === 1;
    const isNextDisabled = pageNumber === Math.ceil(total / pageSize);
    const label = /*#__PURE__*/ _jsxs(Typography, {
        skin: "secondary",
        testId: "".concat(testId, "-label"),
        children: [
            "Viewing ",
            start,
            "-",
            end,
            " of ",
            total
        ]
    });
    return /*#__PURE__*/ _jsx("div", {
        className: cn(styles.root, {
            [styles.compact]: compact
        }),
        "data-testid": testId,
        children: compact ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(IconButton, {
                    skin: "primaryTransparentBoxed",
                    size: "smallMedium",
                    disabled: isPreviousDisabled,
                    testId: "".concat(testId, "-previous"),
                    onClick: ()=>onPageNumberChange(pageNumber - 1),
                    children: /*#__PURE__*/ _jsx(ChevronLeft, {})
                }),
                label,
                /*#__PURE__*/ _jsx(IconButton, {
                    skin: "primaryTransparentBoxed",
                    size: "smallMedium",
                    disabled: isNextDisabled,
                    testId: "".concat(testId, "-next"),
                    onClick: ()=>onPageNumberChange(pageNumber + 1),
                    children: /*#__PURE__*/ _jsx(ChevronRight, {})
                })
            ]
        }) : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                label,
                /*#__PURE__*/ _jsx(Button, {
                    size: "small",
                    skin: "primaryOutline",
                    disabled: isPreviousDisabled,
                    testId: "".concat(testId, "-previous"),
                    onClick: ()=>onPageNumberChange(pageNumber - 1),
                    children: "Previous"
                }),
                /*#__PURE__*/ _jsx(Button, {
                    size: "small",
                    skin: "primaryOutline",
                    disabled: isNextDisabled,
                    testId: "".concat(testId, "-next"),
                    onClick: ()=>onPageNumberChange(pageNumber + 1),
                    children: "Next"
                })
            ]
        })
    });
}
